export default __webpack_public_path__ + "static/media/cohort-small-white.dcda2fb5.svg";